import HttpClient from '@/common/boot/HttpClient';


const listarCircuitos = ({ commit }) => {
  commit('LOADING_CIRCUITOS', true)

  HttpClient.get('gestao-producao/pco-circuitos').then(response => {
    commit('INSERE_CIRCUITOS', response.data.data)
    return response.data
  })
  .finally(()=> {
    commit('LOADING_CIRCUITOS', false)
  })
}

const recuperarCircuitoPorCodigoCir = async ({ commit }, codigoCir) => {
  commit('LOADING_CIRCUITOS', true);

  await HttpClient.get(`gestao-producao/pco-circuitos/codigo-cir/${ codigoCir }`).then(response => {
    commit('INSERE_CIRCUITO_SELECIONADO', response.data.data)
    return response
  })
  .finally(()=> {
    commit('LOADING_CIRCUITOS', false)
  })
}

const buscarMacrofase = async ({ commit }) => {
  
  commit('LOADING_CIRCUITOS', true);

  await HttpClient.get(`/gestao-producao/pco-circuitos/relatorios/visao-macrofase`).then(response => {
      commit('INSERIR_VISAO_MACROFASE', response.data.data);
      return response;
  }).finally( () => {
    commit('LOADING_CIRCUITOS', false);
  });
}

const indicadoresBacklog = async ({ commit }, payload) => {
  commit('LOADING_CIRCUITOS', true);
  const resp =  await HttpClient.post(`/gestao-producao/pco-circuitos/indicadores/backlog-mensal`, payload).then(response => {
      commit('INSERIR_INDICADORES_BACKLOG', response.data.data);
      return response;
  })
  .catch(error => {
    return error.response
  }).finally( () => {
    commit('LOADING_CIRCUITOS', false);
  });

  return resp
}

export {
  listarCircuitos,
  recuperarCircuitoPorCodigoCir,
  buscarMacrofase,
  indicadoresBacklog
}